"use client";

import { useEffect } from "react";
import { isChunkLoadError, reloadOnceForChunk, reportClientError } from "@/lib/mobile/report-error";

// Глобальная ловушка ошибок фронта (заход 07.09): window.onerror и
// необработанные промисы → журнал оператора + Telegram. До этого об ошибке
// на телефоне клиента узнавали только от самого клиента.
export default function ErrorReporter() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onError = (ev: ErrorEvent) => {
      const msg = ev.message || String(ev.error ?? "Unknown error");
      const stack = ev.error instanceof Error ? ev.error.stack : null;
      if (isChunkLoadError(msg)) {
        reportClientError("chunk", msg, stack);
        reloadOnceForChunk();
        return;
      }
      reportClientError("error", msg, stack, { source: ev.filename ? `${ev.filename}:${ev.lineno}:${ev.colno}` : undefined });
    };
    const onRejection = (ev: PromiseRejectionEvent) => {
      const r = ev.reason;
      const msg = r instanceof Error ? r.message : typeof r === "string" ? r : JSON.stringify(r ?? null);
      const stack = r instanceof Error ? r.stack : null;
      if (isChunkLoadError(msg)) {
        reportClientError("chunk", msg, stack);
        reloadOnceForChunk();
        return;
      }
      reportClientError("unhandledrejection", msg, stack);
    };
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);
  return null;
}
